import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CatalogoRequest } from 'src/app/modal/catalogo/catalogo-request';
import { CatalogoResponse } from 'src/app/modal/catalogo/catalogo-response';
import { CatalogoSourvenirRequest } from 'src/app/modal/catalogo/catalogo-sourvenir-request';
import { CatalogoSourvenirResponse } from 'src/app/modal/catalogo/catalogo-sourvenir-response';
import { Generalsearchrequest } from 'src/app/modal/catalogo/generalsearchrequest';
import { ResponseComun } from 'src/app/modal/catalogo/response-comun';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { environment } from 'src/environments/environment';
import { ProtectedImageService } from 'src/app/service/catalogo/protected-image.service';
import { ProtectedImageResponse } from 'src/app/modal/catalogo/protected-image-response';
import { SeoService, SeoSnapshot } from 'src/app/service/seo/seo.service';
import { RateLimitService } from 'src/app/shared/services/rate-limit.service';

@Component({
  selector: 'app-consultas',
  templateUrl: './consultas.component.html',
  styleUrls: ['./consultas.component.scss']
})
export class ConsultasComponent implements OnInit, AfterViewInit, OnDestroy {
  // daet ini
  tagChoosen:string="";
  // daet fin
  idCategoria:string="0";
  idSubCategoria:string="0";
  listProductos:CatalogoResponse = new CatalogoResponse();
  rangoInicio=0;
  rangoFin=4;
  //totalPaginas:any;
  titulo:string;
  busqueda:string;
  subBusqueda:string;
  fMerchadising:boolean=false;
  fSubCategoria:boolean=false;
  listMerchadising:CatalogoSourvenirResponse;
  listCategoria:ResponseComun;
  listSubCategoria:ResponseComun = new ResponseComun();
  paginaActual:number=1;
  generalsearchrequest:Generalsearchrequest;
  Arr = Array; //Array type captured in a variable
  totalPaginas:number;
  totalPaginasArray:any;
  totalPaginasArrayTemp:any;
  LCategoria:any;
  LSubCategoria:any;
  busquedasGeneral=false;
  busquedaPublicaciones=false;
  busquedaMerchadising=false;
  fResultados=false;
  searchStartDate: string = '';
  searchEndDate: string = '';
  searchTerm: string = '';
  searchCategory: string = '';
  tmpIdCategoria:any;
  tmpIdSubCategoria:any;

  filtroBusquedaGeneral:string;

  // Guardar el tipo de búsqueda para paginación
  private currentSearchType: 'tag' | 'text' | 'date' | 'normal' = 'normal';

  // Guardar últimos params para evitar búsquedas duplicadas
  private lastSearchParams: string = '';

  // Sistema de columnas para galería tipo masonry
  columnas = [[], [], []];
  columnas1 = [[], []];
  columnas2: any[];
  showIpad = false;

  protectedImages: Map<string, ProtectedImageResponse> = new Map();
  private imageUrlCache: Map<string, string | null> = new Map();
  private imageLoadStartTimes: Map<string, number> = new Map();
  private imageReadyForDisplay: Map<string, boolean> = new Map();
  public isSkeletonVisible: Map<string, boolean> = new Map();
  private imageOrientations: Map<string, string> = new Map();
  private prevSeo: SeoSnapshot;

  rateLimitActive = false;
  private rateLimitSubscription: any;

constructor(
  private route: ActivatedRoute,
  private novedadesService: NovedadesService,
  private utilitarioService: UtilitarioService,
  private router: Router,
  private protectedImageService: ProtectedImageService,
  private seo: SeoService,
  private toastr: ToastrService,
  private rateLimitService: RateLimitService
) {

  // Escuchar cambios en query params (igual que fotografías)
  this.route.queryParams.subscribe(params => {
    const q = params['q'] || '';
    const fi = params['fi'] || '';
    const ff = params['ff'] || '';
    const cat = params['cat'] || '';
    const page = parseInt(params['page'] || '1', 10);

    // Validar fechas si existen en los query params
    if (fi || ff) {
      // Si solo una fecha está presente, es inválido
      if (!fi || !ff) {
        console.error('❌ [CONSULTAS] Fechas incompletas en query params:', { fi, ff });
        this.toastr.error('Debe proporcionar ambas fechas (inicio y fin).');
        this.utilitarioService.loading = false;
        this.router.navigate(['/consultas'], { queryParams: { page: 1 } });
        return;
      }

      // Validar formato yyyy-MM-dd
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateRegex.test(fi) || !dateRegex.test(ff)) {
        console.error('❌ [CONSULTAS] Formato de fecha inválido en query params:', { fi, ff });
        this.toastr.error('Formato de fecha inválido.');
        this.utilitarioService.loading = false;
        this.router.navigate(['/consultas'], { queryParams: { page: 1 } });
        return;
      }

      // Parsear como fecha LOCAL (evita desplazamiento UTC -> local)
      const fechaIni = this.parseIsoDate(fi);
      const fechaFin = this.parseIsoDate(ff);

      // console.log('🔎 [CONSULTAS] parsed fechaIni:', fechaIni.toString(), 'parsed fechaFin:', fechaFin.toString());

      if (isNaN(fechaIni.getTime()) || isNaN(fechaFin.getTime())) {
        console.error('❌ [CONSULTAS] Fechas inválidas en query params (parse):', { fi, ff });
        this.toastr.error('Las fechas ingresadas no son válidas.');
        this.utilitarioService.loading = false;
        this.router.navigate(['/consultas'], { queryParams: { page: 1 } });
        return;
      }

      // Validar que fecha inicio sea menor o igual a fecha fin
      if (fechaIni.getTime() > fechaFin.getTime()) {
        console.error('❌ [CONSULTAS] Fecha inicio mayor que fecha fin:', { fi, ff });
        this.toastr.error('La fecha de inicio debe ser menor o igual a la fecha de fin.');
        this.utilitarioService.loading = false;
        this.router.navigate(['/consultas'], { queryParams: { page: 1 } });
        return;
      }

      // Validar rango de años razonables (usando años extraídos de las dates locales)
      const yearIni = fechaIni.getFullYear();
      const yearFin = fechaFin.getFullYear();
      const currentYear = new Date().getFullYear();

      // console.log('🔎 [CONSULTAS] yearIni:', yearIni, 'yearFin:', yearFin, 'currentYear:', currentYear);

      if (yearIni < 1825 || yearIni > currentYear || yearFin < 1825 || yearFin > currentYear) {
        console.error('❌ [CONSULTAS] Años fuera de rango válido:', { yearIni, yearFin });
        this.toastr.error(`Los años deben estar entre 1825 y ${currentYear}.`);
        this.utilitarioService.loading = false;
        this.router.navigate(['/consultas'], { queryParams: { page: 1 } });
        return;
      }
    }

    // Guardar las fechas, término y categoría de búsqueda para mostrarlas en el header de resultados
    this.searchStartDate = fi;
    this.searchEndDate = ff;
    this.searchTerm = q;
    this.searchCategory = cat;

    // Crear un string único para estos params
    const currentParams = `${q}|${fi}|${ff}|${cat}|${page}`;

    // console.log('🔄 [CONSULTAS] QueryParams detectados:', { page, q, fi, ff, cat });
    // console.log('🔄 [CONSULTAS] Params actuales:', currentParams);
    // console.log('🔄 [CONSULTAS] Últimos params:', this.lastSearchParams);

    // Evitar búsquedas duplicadas
    if (this.lastSearchParams === currentParams) {
      // console.log('⏭️ [CONSULTAS] Parámetros idénticos, evitando búsqueda duplicada');
      return;
    }

    this.lastSearchParams = currentParams;
    // console.log('🔄 [CONSULTAS] Página actual antes:', this.paginaActual);

    this.paginaActual = isNaN(page) ? 1 : page;
    this.utilitarioService.busqueda = q;
    this.utilitarioService.fecIni = fi;
    this.utilitarioService.fecFin = ff;
    // Convertir categoría a mayúsculas para el backend
    this.utilitarioService.categoria = cat ? cat.toUpperCase() : '';

    // console.log('🔄 [CONSULTAS] Nueva página:', this.paginaActual);
    // console.log('🔄 [CONSULTAS] tipobusqueda:', this.utilitarioService.tipobusqueda);
    // console.log('🔄 [CONSULTAS] currentSearchType guardado:', this.currentSearchType);

    // Determinar el flujo según los parámetros
    if (this.utilitarioService.tipobusqueda === 'tag' || this.currentSearchType === 'tag') {
      // console.log('✅ [CONSULTAS] Ejecutando búsqueda por tag');
      this.currentSearchType = 'tag';
      this.obtenerCategoriasBasico2();
    } else if (q) {
      // console.log('✅ [CONSULTAS] Ejecutando búsqueda por texto:', q);
      this.currentSearchType = 'text';
      this.obtenerCategoriasBasico2();
    } else if (fi && ff) {
      // console.log('✅ [CONSULTAS] Ejecutando búsqueda por fechas, página:', page);
      this.currentSearchType = 'date';
      // Si ya estaba en búsqueda por fechas y solo cambió la página, ejecutar directamente busquedaGeneral
      if (this.listProductos?.response?.list && this.listProductos.response.list.length > 0) {
        // console.log('✅ [CONSULTAS] Paginación en búsqueda por fechas');
        this.busquedaGeneral();
      } else {
        // console.log('✅ [CONSULTAS] Primera búsqueda por fechas');
        this.obtenerCategoriasBasico();
      }
    } else {
      // console.log('✅ [CONSULTAS] Ejecutando búsqueda normal');
      this.currentSearchType = 'normal';
      this.obtenerCategorias();
    }
  },


);
}


private parseIsoDate(iso: string): Date {
  if (!iso || iso.length < 10) return new Date(NaN);
  const y = Number(iso.substring(0, 4));
  const m = Number(iso.substring(5, 7));
  const d = Number(iso.substring(8, 10));
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return new Date(NaN);
  return new Date(y, m - 1, d); // crea fecha LOCAL (00:00 local)
}


  // daet1
  detalleComponente(idSeleccionado, titleShowUrl, categoryName){
    // console.log("idSeleccionado:"+idSeleccionado);
    this.utilitarioService.idSeleccionado = idSeleccionado;

    // Determinar ruta según categoryName
    let route = '/dt/'; // default (FOTOGRAFIAS)
    if (categoryName === 'FOTOGRAFIAS') {
      route = '/dt/'; // FOTOGRAFIAS
    } else if (categoryName === 'PORTADAS_HISTORICAS') {
      route = '/dtp/'; // PORTADAS HISTORICAS
    }

    this.router.navigate([route + titleShowUrl, idSeleccionado]);
  }
  
  obtenerCategorias(){
    // console.log("obtenerCategorias");
    this.listCategoria = new ResponseComun();
    this.novedadesService.obtenerCategoria().subscribe(data=>{
      this.listCategoria = data;
      // console.log(this.listCategoria);      
      // console.log("this.novedadesService.idCategoria: ",this.novedadesService.idCategoria);
      

      if(this.novedadesService.idCategoria!=null && this.novedadesService.idCategoria>0){
        // console.log("call obtenerSubcategoria"); 
        this.obtenerSubcategoria(this.novedadesService.idCategoria);
      }else{
        // console.log("call cambiarCategoria"); 
        //this.novedadesService.idCategoria=1;
        //this.obtenerSubcategoria(this.novedadesService.idCategoria);
        this.cambiarCategoria("FOTOGRAFIAS");
      }

      //this.obtenerSubcategoria("FOTOGRAFIAS");
      //this.cambiarCategoria("FOTOGRAFIAS");
    });
  }

  obtenerCategoriasBasico(){
    
    // console.log("obtenerCategoriasBasico");
    this.listCategoria = new ResponseComun();
    this.novedadesService.obtenerCategoria().subscribe(data=>{
      this.listCategoria = data;
      // console.log(this.listCategoria); 
      //console.log("this.novedadesService.idCategoria ",this.novedadesService.idCategoria);
      //this.obtenerSubcategoria(this.novedadesService.idCategoria);
      if(this.novedadesService.idCategoria!=null && this.novedadesService.idCategoria>0){
        // console.log("1"); 
        //this.obtenerSubcategoria(this.novedadesService.idCategoria);
      }else{
        // console.log("2"); 
        //this.novedadesService.idCategoria=1;
        //this.obtenerSubcategoria(1);
        //this.obtenerSubcategoriaBasico(1);
        //this.LSubCategoria="TODOS";
        //this.cambiarCategoria("FOTOGRAFIAS");
        this.cambiarCategoriaBasico("FOTOGRAFIAS");
      }
      this.busquedaGeneral();
     
    });
  }

  // daet ini
  obtenerCategoriasBasico2(){
    // console.log("obtenerCategoriasBasico2");
    // console.log("🔍 [obtenerCategoriasBasico2] Página actual antes de buscar:", this.paginaActual);

    // Directamente ejecutar la búsqueda sin resetear valores
    // Ya no necesitamos obtener categorías ni cambiar categoría
    this.busquedaGeneral2();
  }
  // daet fin

  consultarBusqueda(){
    // console.log("consultarBusqueda idCategoria:"+this.idCategoria);
    this.obtenerCategorias();
    switch(this.idCategoria){
      case "1":
        this.titulo="FOTOGRAFIAS";
        this.busqueda="FOTOGRAFIAS";
        break;
      case "2":
        this.titulo="PORTADAS HISTORICAS";
        this.busqueda="PORTADAS_HISTORICAS";
        break;
      case "3":
        this.titulo="MERCHANDISING";
        break;
    }
    if(this.utilitarioService.busqueda!="" && this.utilitarioService.busqueda!=null){
      // console.log("consultarBusqueda>>old");
      this.busquedaGeneral();
      this.fSubCategoria = false;
    // daet ini  
    }else if(this.utilitarioService.fecIni!="" && this.utilitarioService.fecIni!=null && this.utilitarioService.fecFin!="" && this.utilitarioService.fecFin!=null){
      // console.log("consultarBusqueda>>new");
      this.busquedaGeneral();
      this.fSubCategoria = false;
    // daet fin  
    }
    else{
      // console.log("consultarBusqueda>>else");
      if(this.idCategoria=="3"){
        this.fMerchadising=true;
        this.fSubCategoria = false;
        this.buscarMerchadasing();
      }    
      else{     
        this.fMerchadising=false;
        this.buscarPublicaciones();
        this.fSubCategoria = true;
        // console.log("fSubCategoria",this.fSubCategoria);
        this.obtenerSubcategoria(this.idCategoria);
      }
    }
  }

  obtenerSubcategoria(id){
    // console.log("obtenerSubcategoria x categoria",id);
    this.novedadesService.obtenerSubCategoria(id).subscribe(data=>{
      this.listSubCategoria = data;
      if(this.listSubCategoria.response.list.length>0){
        this.fSubCategoria=true;
      }
      this.busqueda = this.listCategoria.response.list.find(data=>data.id==this.tmpIdCategoria).name;
      this.titulo = this.busqueda.toLowerCase();
      // console.log("this.titulo:"+this.titulo);
      
      // console.log("tmpIdSubCategoria",this.tmpIdSubCategoria);
      this.LCategoria=this.busqueda;
      if(this.tmpIdSubCategoria!=null && this.tmpIdSubCategoria!=""){
        this.subBusqueda = this.listSubCategoria.response.list.find(data=>data.id==this.tmpIdSubCategoria).name;
        this.LSubCategoria=this.subBusqueda;

      }
      else{
        this.subBusqueda = "";
        this.LSubCategoria=this.listSubCategoria.response.list[0].name;
      }
    
      this.buscarPublicaciones();

    });
  }
  cambiarCategoria(id){
   // this.router.navigate(["/consultas/",id]);
   this.busqueda = id;
   // console.log("cambiarCategoriaXX:",id);
   this.titulo = this.busqueda.toLowerCase();
   // console.log("xxxxxxxxxxxxxxxxxxxxxx"+this.utilitarioService.idCategoria);
      // daet1 ini 
      switch(this.utilitarioService.idCategoria){
        case "1":
          this.titulo="FOTOGRAFIAS";
          break;
        case "2":
          this.titulo="PORTADAS_HISTORICAS";
          break;
        case "3":
          this.titulo="HEMEROTECA_DIGITAL";
          break;
      }
      // daet1 fin

   // console.log("this.tituloXXXXXXXXXXXXXXXXXXXXXXX2:"+this.titulo);

   this.subBusqueda = "TODOS";
   //this.fSubCategoria = true;
   this.LCategoria=this.busqueda;
   this.LSubCategoria=this.subBusqueda;
   this.paginaActual=1;
   this.buscarPublicaciones();
   this.obtenerSubcategoriaBasico(this.listCategoria.response.list.find(data=>data.name==id).id);
  }

  cambiarCategoriaBasico(id){
   // this.router.navigate(["/consultas/",id]);
   this.busqueda = id;
   // console.log("cambiarCategoria:",id);

   //daet1 ini
   switch(this.utilitarioService.idCategoria){
    case "1":
      this.titulo="FOTOGRAFIAS";
      break;
    case "2":
      this.titulo="PORTADAS HISTORICAS";
      break;
    case "3":
      this.titulo="MERCHANDISING";
      break;
   }
   // daet1 fin

   //this.titulo = this.busqueda.toUpperCase();
   // console.log("this.tituloXXXXXXXXXXXXXXXXXXXXXXX2:"+this.titulo);
   this.subBusqueda = "TODOS";
   //this.fSubCategoria = true;
   this.LCategoria=this.busqueda;
   this.LSubCategoria=this.subBusqueda;
   this.paginaActual=1;
   //this.buscarPublicaciones();
   this.obtenerSubcategoriaBasico(this.listCategoria.response.list.find(data=>data.name==id).id);
  }

  obtenerSubcategoriaBasico(id){
    // console.log("id",id);
    this.novedadesService.obtenerSubCategoria(id).subscribe(data=>{
      this.listSubCategoria = data;
      if(this.listSubCategoria.response.list.length>0){
        this.fSubCategoria=true;
      }
      this.subBusqueda = this.listSubCategoria.response.list[0].name;
    });
  }

  cambiarSubCategoria(id){
    //this.router.navigate(["/consultas/",this.idCategoria,id]);
    this.subBusqueda=id;
    this.paginaActual=1;
    this.buscarPublicaciones();
  }


  buscarPublicaciones(){
    // console.log("buscarPublicaciones");

    // Limpiar datos inmediatamente al iniciar búsqueda
    this.fResultados = false;
    this.listProductos = new CatalogoResponse();
    this.columnas = [[], [], []];
    this.columnas1 = [[], []];
    this.columnas2 = [];
    this.clearProtectedImagesCache();

    this.utilitarioService.loading= true;
    // console.log("LCate",this.LCategoria);
    // console.log("LSubCate",this.LSubCategoria);

    let catalogoRequest:CatalogoRequest;
    catalogoRequest = new CatalogoRequest();    
    catalogoRequest.authorId="0";
    catalogoRequest.categoryId="0";
    catalogoRequest.categoryName=this.busqueda;
    catalogoRequest.page=this.paginaActual.toString();
    catalogoRequest.subCategoryId="0";
    catalogoRequest.subCategoryName=this.subBusqueda;
    catalogoRequest.publicationId="0";
    catalogoRequest.size="12";
    catalogoRequest.title="";
    catalogoRequest.yearId="0";
    // console.log("catalogoRequest",catalogoRequest);

    if (this.LCategoria=="HEMEROTECA_DIGITAL"){
      this.fSubCategoria=false;
    }

    this.novedadesService.buscarCatalogo(catalogoRequest).subscribe(data=>{
      if(data.response.codeResponse=="0000"){
        this.listProductos = data;
        this.totalPaginas = Number(this.listProductos.response.nroTotalPaginas);
        this.totalPaginasArray = Array.from(Array(Number(this.listProductos.response.nroTotalPaginas)).keys());

        // Limpiar columnas
        this.columnas = [[], [], []];
        this.columnas1 = [[], []];
        this.columnas2 = [];

        // Cargar tokens para las imágenes de la página actual
        this.loadTokensForCurrentPage();

        this.busquedasGeneral=false;
        this.busquedaPublicaciones=true;
        this.busquedaMerchadising=false;
        // Actualizar rangos de paginación
        this.actualizarRangosPaginacion();
        this.totalPaginasArrayTemp = this.filterRange(this.totalPaginasArray,this.rangoInicio,this.rangoFin);
        this.novedadesService.idCategoria="";
        this.novedadesService.idSubCategoria="";
        this.utilitarioService.busqueda="";
        this.fResultados=true;

        // Organizar en columnas y cargar imágenes
        this.listProductos.response.list.forEach((item, index) => {
          // console.log('🔍 Item:', item.title, '| categoryName:', item.categoryName, '| titleShowUrl:', item.titleShowUrl);
          const columnaIndex = index % 3;
          this.columnas[columnaIndex].push(item);
          this.loadProtectedThumbnail(item.activoId);
        });

        this.listProductos.response.list.forEach((item, index) => {
          const columnaIndex = index % 2;
          this.columnas1[columnaIndex].push(item);
        });

        // Configurar columnas según dispositivo
        if (this.isIPad()) {
          this.columnas2 = this.columnas1;
          this.showIpad = true;
        } else {
          this.columnas2 = this.columnas;
          this.showIpad = false;
        }

      }
      else{
        this.fResultados=false;
        this.novedadesService.idCategoria="";
        this.novedadesService.idSubCategoria="";
        this.utilitarioService.busqueda="";
      }
      this.utilitarioService.loading= false;
    })
  }
  filterRange(arr, a, b) {
    if(arr!=null && a!=null && b!=null){
      return arr.filter((item) => a <= item && item <= b);
    }
    else{
      return false;
    }
  }
  buscarMerchadasing(){
    let catalogoSourvenirRequest:CatalogoSourvenirRequest = new CatalogoSourvenirRequest();
    this.listMerchadising = new CatalogoSourvenirResponse();
    catalogoSourvenirRequest.groupId="0";
    catalogoSourvenirRequest.page=this.paginaActual.toString();
    catalogoSourvenirRequest.size="12";
    catalogoSourvenirRequest.submenuId="2";
    catalogoSourvenirRequest.topicId="0";
    this.novedadesService.buscarCatalogoSourvenir(catalogoSourvenirRequest).subscribe(data=>{
      // console.log("data",data);
      if(data.response.codeResponse=="0000"){
        this.listMerchadising = data;
        this.busquedasGeneral=false;
        this.busquedaPublicaciones=false;
        this.busquedaMerchadising=true;   
      }
    })
  }

  cambiarPagina(pagina: number) {
    // Evitar valores fuera de rango
    if (pagina < 1) pagina = 1;
    if (pagina > this.totalPaginas) pagina = this.totalPaginas;

    // Si ya estamos en esa página, no hacer nada
    if (pagina === this.paginaActual) {
      // console.log('Ya estás en la página', pagina);
      return;
    }

    // Activar loading solo si vamos a cambiar de página
    this.utilitarioService.loading = true;

    // Construir queryParams manteniendo TODOS los parámetros actuales
    let queryParams: any = {};

    // Agregar búsqueda si existe
    if (this.utilitarioService.busqueda) {
      queryParams.q = this.utilitarioService.busqueda;
    }

    // Agregar fechas si existen
    if (this.utilitarioService.fecIni && this.utilitarioService.fecFin) {
      queryParams.fi = this.utilitarioService.fecIni;
      queryParams.ff = this.utilitarioService.fecFin;
    }

    // Agregar categoría si existe
    if (this.utilitarioService.categoria) {
      queryParams.cat = this.utilitarioService.categoria;
    }

    // Siempre agregar página
    queryParams.page = pagina;

    // Actualizar la URL con todos los parámetros
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams
    });
  }

  actualizarRangosPaginacion() {
    const pagina = this.paginaActual;
    const isMobile = window.innerWidth <= 991;

    if (isMobile) {
      // Mostrar solo 3 números de página en mobile (página actual ± 1)
      const halfRange = 1;
      this.rangoInicio = Math.max(0, pagina - halfRange);
      this.rangoFin = Math.min(this.totalPaginas - 1, pagina + halfRange);

      // Asegurar que siempre se muestren 3 páginas si hay suficientes
      if (this.rangoFin - this.rangoInicio < 2 && this.totalPaginas >= 3) {
        if (pagina === 0) {
          this.rangoFin = Math.min(2, this.totalPaginas - 1);
        } else if (pagina === this.totalPaginas - 1) {
          this.rangoInicio = Math.max(0, this.totalPaginas - 3);
        }
      }
    } else {
      // Lógica original para desktop (5 números)
      this.rangoInicio = pagina - 3;
      this.rangoFin = pagina + 1;

      if (pagina == 0 || pagina == 1) {
        this.rangoInicio = 0;
        this.rangoFin = 4;
      }

      if (pagina >= this.totalPaginas) {
        this.rangoInicio = pagina - 5;
        this.rangoFin = pagina;
      }

      if (pagina == 2) {
        this.rangoInicio = 0;
        this.rangoFin = pagina + 2;
      }
    }
  }

  active(pagina){
    //console.log('🔍 [CONSULTAS] active() - paginaActual:', this.paginaActual, 'pagina:', pagina, 'igual?:', this.paginaActual == pagina);
    return this.paginaActual==pagina?"active":"";
  }
  imagen(img:String){
    
    //let url = img.replace(/_=2?/g,"");
    let url = img.slice(0,img.length);
    // url = url.replace(/_=1?/,"");
    return url;
  }

  busquedaGeneral(){
    // console.log("busquedaGeneral");
    this.clearProtectedImagesCache(); // Limpiar cache antes de nueva búsqueda
    this.generalsearchrequest = new Generalsearchrequest();
    //console.log(this.txtBusqueda);
    this.filtroBusquedaGeneral = this.utilitarioService.busqueda;

    this.generalsearchrequest.busquedaGeneral=this.utilitarioService.busqueda;
    // daet ini
    this.tagChoosen="";
    this.generalsearchrequest.fecIni=this.utilitarioService.fecIni;
    this.generalsearchrequest.fecFin=this.utilitarioService.fecFin;
    // daet fin
    this.generalsearchrequest.categoria=this.utilitarioService.categoria;
    this.generalsearchrequest.page=this.paginaActual.toString();
    this.generalsearchrequest.size="12";
    this.utilitarioService.loading=true;

    // console.log("generalsearchrequest",this.generalsearchrequest);
    this.novedadesService.buscarCatalogoGeneral(this.generalsearchrequest).subscribe(data=>{
      // console.log("data",data);
      if(data.response.codeResponse=="0000"){
        this.busquedasGeneral=true;
        this.busquedaPublicaciones=false;
        this.busquedaMerchadising=false;
        this.listProductos = data;
        this.totalPaginas = Number(this.listProductos.response.nroTotalPaginas);
        this.totalPaginasArray = Array.from(Array(Number(this.listProductos.response.nroTotalPaginas)).keys());

        // Limpiar columnas antes de llenar
        this.columnas = [[], [], []];
        this.columnas1 = [[], []];

        // Cargar tokens para las imágenes de la página actual
        this.loadTokensForCurrentPage();
        this.subBusqueda="";
        // Actualizar rangos de paginación
        this.actualizarRangosPaginacion();
        this.totalPaginasArrayTemp = this.filterRange(this.totalPaginasArray,this.rangoInicio,this.rangoFin);
        this.fMerchadising=false;
        this.novedadesService.idCategoria="";
        this.novedadesService.idSubCategoria="";
        // NO limpiar utilitarioService.busqueda para que funcione la paginación
        this.fResultados=true;

        // Organizar en columnas (igual que busquedaGeneral2)
        this.listProductos.response.list.forEach((item, index) => {
          // console.log('🔍 [FECHAS] Item:', item.title, '| categoryName:', item.categoryName, '| titleShowUrl:', item.titleShowUrl);
          const columnaIndex = index % 3;
          this.columnas[columnaIndex].push(item);
          this.loadProtectedThumbnail(item.activoId);
        });

        this.listProductos.response.list.forEach((item, index) => {
          const columnaIndex = index % 2;
          this.columnas1[columnaIndex].push(item);
        });

        // Configurar columnas según dispositivo
        if (this.isIPad()) {
          this.columnas2 = this.columnas1;
          this.showIpad = true;
        } else {
          this.columnas2 = this.columnas;
          this.showIpad = false;
        }

      }
      else{
        this.fResultados=false;
        this.novedadesService.idCategoria="";
        this.novedadesService.idSubCategoria="";
        // NO limpiar para que funcione la paginación si hay error temporal
      }
      this.utilitarioService.loading=false;
    })
  }

  // daet ini
  busquedaGeneral2(){
    // console.log("🔍 [busquedaGeneral2] Iniciando búsqueda");
    // console.log("🔍 [busquedaGeneral2] Página actual:", this.paginaActual);
    // console.log("🔍 [busquedaGeneral2] Búsqueda:", this.utilitarioService.busqueda);

    this.clearProtectedImagesCache(); // Limpiar cache antes de nueva búsqueda
    this.tagChoosen=this.utilitarioService.busqueda;
    this.generalsearchrequest = new Generalsearchrequest();
    this.filtroBusquedaGeneral = this.utilitarioService.busqueda;

    this.generalsearchrequest.busquedaGeneral=this.utilitarioService.busqueda;
    this.generalsearchrequest.fecIni=this.utilitarioService.fecIni;
    this.generalsearchrequest.fecFin=this.utilitarioService.fecFin;
    this.generalsearchrequest.categoria=this.utilitarioService.categoria;
    this.generalsearchrequest.page=this.paginaActual.toString();
    this.generalsearchrequest.size="12";
    this.utilitarioService.loading=true;

    // console.log("🔍 [busquedaGeneral2] Request:", this.generalsearchrequest);
    this.novedadesService.buscarCatalogoGeneral2(this.generalsearchrequest).subscribe(data=>{
      // console.log("data",data);
      if(data.response.codeResponse=="0000"){
        this.busquedasGeneral=true;
        this.busquedaPublicaciones=false;
        this.busquedaMerchadising=false;
        this.listProductos = data;
        this.totalPaginas = Number(this.listProductos.response.nroTotalPaginas);
        this.totalPaginasArray = Array.from(Array(Number(this.listProductos.response.nroTotalPaginas)).keys());

        // Limpiar columnas
        this.columnas = [[], [], []];
        this.columnas1 = [[], []];
        this.columnas2 = [];

        // Cargar tokens para las imágenes de la página actual
        this.loadTokensForCurrentPage();
        this.subBusqueda="";
        // Actualizar rangos de paginación
        this.actualizarRangosPaginacion();
        this.totalPaginasArrayTemp = this.filterRange(this.totalPaginasArray,this.rangoInicio,this.rangoFin);
        this.fMerchadising=false;
        this.novedadesService.idCategoria="";
        this.novedadesService.idSubCategoria="";
        // NO limpiar utilitarioService.busqueda ni tipobusqueda para que funcione la paginación
        this.fResultados=true;

        // Organizar en columnas
        this.listProductos.response.list.forEach((item, index) => {
          // console.log('🔍 [TAG] Item:', item.title, '| categoryName:', item.categoryName, '| titleShowUrl:', item.titleShowUrl);
          const columnaIndex = index % 3;
          this.columnas[columnaIndex].push(item);
          this.loadProtectedThumbnail(item.activoId);
        });

        this.listProductos.response.list.forEach((item, index) => {
          const columnaIndex = index % 2;
          this.columnas1[columnaIndex].push(item);
        });

        // Configurar columnas según dispositivo
        if (this.isIPad()) {
          this.columnas2 = this.columnas1;
          this.showIpad = true;
        } else {
          this.columnas2 = this.columnas;
          this.showIpad = false;
        }

      }
      else{
        this.fResultados=false;
        this.novedadesService.idCategoria="";
        this.novedadesService.idSubCategoria="";
        // NO limpiar para que funcione la paginación si hay error temporal
      }
      this.utilitarioService.loading=false;
    })
  }
  // daet fin
    
  busquedaGeneralPaginacion(){
    // console.log("busquedaGeneralPaginacion");
    this.generalsearchrequest = new Generalsearchrequest();
    //console.log(this.txtBusqueda);

    this.generalsearchrequest.busquedaGeneral=this.filtroBusquedaGeneral;
    // daet ini
    this.generalsearchrequest.fecIni=this.utilitarioService.fecIni;
    this.generalsearchrequest.fecFin=this.utilitarioService.fecFin;
    // daet fin
    this.generalsearchrequest.categoria=this.utilitarioService.categoria;
    this.generalsearchrequest.page=this.paginaActual.toString();
    this.generalsearchrequest.size="12";
    this.utilitarioService.loading=true;

    // console.log("generalsearchrequest",this.generalsearchrequest);
    this.novedadesService.buscarCatalogoGeneral(this.generalsearchrequest).subscribe(data=>{
      // console.log("data",data);
      if(data.response.codeResponse=="0000"){
        this.busquedasGeneral=true;
        this.busquedaPublicaciones=false;
        this.busquedaMerchadising=false;
        this.listProductos = data;
        this.totalPaginas = Number(this.listProductos.response.nroTotalPaginas);
        this.totalPaginasArray = Array.from(Array(Number(this.listProductos.response.nroTotalPaginas)).keys());

        // Limpiar columnas antes de llenar
        this.columnas = [[], [], []];
        this.columnas1 = [[], []];

        // Cargar tokens para las imágenes de la página actual
        this.loadTokensForCurrentPage();
        this.subBusqueda="";
        // Actualizar rangos de paginación
        this.actualizarRangosPaginacion();
        this.totalPaginasArrayTemp = this.filterRange(this.totalPaginasArray,this.rangoInicio,this.rangoFin);
        this.fMerchadising=false;
        //this.novedadesService.idCategoria="";//daet1
        this.novedadesService.idSubCategoria="";
        this.utilitarioService.busqueda="";
        this.fResultados=true;

        // Organizar en columnas (igual que busquedaGeneral)
        this.listProductos.response.list.forEach((item, index) => {
          // console.log('🔍 [PAGINACION-FECHAS] Item:', item.title, '| categoryName:', item.categoryName, '| titleShowUrl:', item.titleShowUrl);
          const columnaIndex = index % 3;
          this.columnas[columnaIndex].push(item);
          this.loadProtectedThumbnail(item.activoId);
        });

        this.listProductos.response.list.forEach((item, index) => {
          const columnaIndex = index % 2;
          this.columnas1[columnaIndex].push(item);
        });

        // Configurar columnas según dispositivo
        if (this.isIPad()) {
          this.columnas2 = this.columnas1;
          this.showIpad = true;
        } else {
          this.columnas2 = this.columnas;
          this.showIpad = false;
        }

      }
      else{
        this.fResultados=false;
        //this.novedadesService.idCategoria="";//daet1
        this.novedadesService.idSubCategoria="";
        this.utilitarioService.busqueda="";
      }
      this.utilitarioService.loading=false;
    })
  }

  // daet ini
  busquedaGeneralPaginacion2(){
    // console.log("busquedaGeneralPaginacion2");
    this.generalsearchrequest = new Generalsearchrequest();
    //console.log(this.txtBusqueda);

    this.generalsearchrequest.busquedaGeneral=this.filtroBusquedaGeneral;
    this.generalsearchrequest.categoria=this.utilitarioService.categoria;
    this.generalsearchrequest.page=this.paginaActual.toString();
    this.generalsearchrequest.size="12";
    this.utilitarioService.loading=true;

    // console.log("generalsearchrequest",this.generalsearchrequest);
    this.novedadesService.buscarCatalogoGeneral2(this.generalsearchrequest).subscribe(data=>{ 
      // console.log("data",data);     
      if(data.response.codeResponse=="0000"){     
        this.busquedasGeneral=true;
        this.busquedaPublicaciones=false;
        this.busquedaMerchadising=false;   
        this.listProductos = data;
        this.totalPaginas = Number(this.listProductos.response.nroTotalPaginas);
        this.totalPaginasArray = Array.from(Array(Number(this.listProductos.response.nroTotalPaginas)).keys());

        // Cargar tokens para las imágenes de la página actual
        this.loadTokensForCurrentPage();
        this.subBusqueda="";
        // Actualizar rangos de paginación
        this.actualizarRangosPaginacion();
        this.totalPaginasArrayTemp = this.filterRange(this.totalPaginasArray,this.rangoInicio,this.rangoFin);
        this.fMerchadising=false;        
        //this.novedadesService.idCategoria=""; //daet1
        this.novedadesService.idSubCategoria="";        
        this.utilitarioService.busqueda="";
        this.fResultados=true;
      }
      else{
        this.fResultados=false;
        //this.novedadesService.idCategoria="";//daet1
        this.novedadesService.idSubCategoria="";
        this.utilitarioService.busqueda="";
      }
      this.utilitarioService.loading=false;
    })
  }
  // daet fin

  loadProtectedThumbnail(imageId: string): void {
    if (!imageId) {
      return;
    }

    // Evitar múltiples peticiones para la misma imagen
    if (this.protectedImages.has(imageId)) {
      // console.log('⚠️ [CONSULTAS] Intento de carga duplicada bloqueado:', imageId);
      return;
    }

    //console.log('🔄 [CONSULTAS] Iniciando carga de imagen:', imageId);

    // Marcar como en proceso
    this.protectedImages.set(imageId, {
      imageId: imageId,
      protectedThumbnailUrl: null,
      expiresIn: 0,
      loadedAt: Date.now()
    });

    this.protectedImageService.getProtectedThumbnail(imageId).subscribe({
      next: (response) => {
        // Calcular orientación basada en metadata y actualizar si es necesario
        if (response.metadata && response.metadata.width && response.metadata.height) {
          const width = parseInt(String(response.metadata.width));
          const height = parseInt(String(response.metadata.height));
          const ratio = width / height;

          if (Math.abs(ratio - 1) < 0.1) {
            this.imageOrientations.set(imageId, 'square');
          } else if (height > width) {
            this.imageOrientations.set(imageId, 'portrait');
          } else {
            this.imageOrientations.set(imageId, 'landscape');
          }
        }

        response.loadedAt = Date.now();
        this.protectedImages.set(imageId, response);
        this.imageUrlCache.set(imageId, response.protectedThumbnailUrl);

        // Calcular tiempo transcurrido desde que inició la carga
        const startTime = this.imageLoadStartTimes.get(imageId) || Date.now();
        const elapsedTime = Date.now() - startTime;
        const minimumDelay = 800; // 800ms mínimo para apreciar el skeleton

        const timeToWait = Math.max(0, minimumDelay - elapsedTime);

        // console.log('⏱️ [CONSULTAS] Imagen cargada:', imageId, 'Tiempo transcurrido:', elapsedTime, 'ms, Esperando:', timeToWait, 'ms más');

        setTimeout(() => {
          // console.log('🖼️ [CONSULTAS] Ocultando skeleton y mostrando imagen:', imageId);
          this.isSkeletonVisible.set(imageId, false);
          this.imageReadyForDisplay.set(imageId, true);
        }, timeToWait);

        // console.log('✅ Token recibido para consultas:', imageId);
      },
      error: (error) => {
        console.error('❌ Error cargando imagen en consultas:', imageId, error);
        this.protectedImages.delete(imageId);
        this.imageLoadStartTimes.delete(imageId);
        this.isSkeletonVisible.delete(imageId);
        this.imageOrientations.delete(imageId);
      }
    });
  }

  // Cargar tokens de forma inteligente para elementos visibles
  loadTokensForCurrentPage(): void {
    if (!this.listProductos?.response?.list) return;

    const currentPageItems = this.listProductos.response.list;
    // console.log('🔄 [CONSULTAS] Cargando tokens para', currentPageItems.length, 'elementos de la página actual');

    // PRIMERO: Pre-inicializar orientaciones Y tiempos de inicio para todos los items
    // Esto asegura que el skeleton se muestre inmediatamente
    // console.log('📝 [CONSULTAS] Pre-inicializando orientaciones y tiempos...');
    const now = Date.now();
    currentPageItems.forEach(item => {
      if (item.activoId && !this.imageOrientations.has(item.activoId)) {
        // console.log('  ➕ Estableciendo orientación landscape y tiempo inicio para:', item.activoId);
        this.imageOrientations.set(item.activoId, 'landscape');
        this.imageLoadStartTimes.set(item.activoId, now);
        this.isSkeletonVisible.set(item.activoId, true);
      }
    });
    // console.log('✅ [CONSULTAS] Orientaciones inicializadas. Total:', this.imageOrientations.size);

    // SEGUNDO: Cargar las imágenes
    currentPageItems.forEach(item => {
      if (item.activoId) {
        this.loadProtectedThumbnail(item.activoId);
      }
    });
  }

  getProtectedImageUrl(imageId: string): string | null {
    if (!imageId) {
      return null;
    }

    // Si el skeleton está visible, no mostrar imagen aún
    if (this.isSkeletonVisible.get(imageId)) {
      return null;
    }

    // Si ya no está el skeleton, devolver la URL desde el cache
    return this.imageUrlCache.get(imageId) || null;
  }

  // Método público para el template
  shouldShowSkeleton(imageId: string): boolean {
    if (!imageId) {
      return false;
    }

    // Solo mostrar skeleton si ya se calculó la orientación
    if (!this.imageOrientations.has(imageId)) {
      return false; // No mostrar nada hasta que se calcule orientación
    }

    // Simplemente devolver el estado actual sin modificarlo
    // La inicialización se hace en loadTokensForCurrentPage()
    const result = this.isSkeletonVisible.get(imageId) || false;
    if (result) {
      // console.log('👁️ shouldShowSkeleton TRUE para:', imageId);
    }
    return result;
  }

  // Obtener clase de orientación para el skeleton
  getSkeletonOrientationClass(imageId: string): string {
    const orientation = this.imageOrientations.get(imageId);
    if (orientation === 'portrait') {
      return 'skeleton-portrait';
    } else if (orientation === 'square') {
      return 'skeleton-landscape';
    }
    return 'skeleton-landscape'; // Por defecto
  }

  clearProtectedImagesCache(): void {
    this.protectedImages.clear();
    this.imageUrlCache.clear();
    this.imageLoadStartTimes.clear();
    this.imageReadyForDisplay.clear();
    this.isSkeletonVisible.clear();
    this.imageOrientations.clear();
  }

  // Método para calcular el aspect-ratio basado en orientación real o metadatos
  getSkeletonAspectRatio(item: any): string {
    // Si ya tenemos la orientación calculada del servicio, usarla
    if (item.activoId && this.imageOrientations.has(item.activoId)) {
      const orientation = this.imageOrientations.get(item.activoId);

      if (orientation === 'portrait') {
        return '3 / 4'; // Vertical
      } else if (orientation === 'square') {
        return '1 / 1'; // Cuadrado
      } else {
        return '4 / 3'; // Horizontal (landscape)
      }
    }

    // Fallback: usar metadatos del item si están disponibles
    if (item.width && item.height) {
      const width = +item.width;
      const height = +item.height;
      return `${width} / ${height}`;
    }

    // Default: landscape
    return '4 / 3';
  }

  isIPad(): boolean {
    const userAgent = navigator.userAgent;
    const iPadT = navigator.userAgent.match(/iPad/i);
    const iPadString = iPadT ? iPadT[0] : '';
    return iPadString === "iPad";
  }

  ngOnInit(): void {
    // Suscribirse al estado del rate limit
    this.rateLimitSubscription = this.rateLimitService.rateLimitState$.subscribe(
      state => {
        this.rateLimitActive = state.isActive && state.timeRemaining > 0;
      }
    );

    // Limpiar cache al inicializar el componente para nueva navegación
    this.clearProtectedImagesCache();

    // Guardar SEO anterior para restaurar al destruir el componente
    this.prevSeo = this.seo.snapshot();

    // SEO para Consultas: "Consultas | Archivo Histórico | Diario Oficial El Peruano"
    this.seo.setMeta({
      title: 'Consultas | Archivo Histórico',
      suffix: 'Diario Oficial El Peruano',
      description: 'Resultados de búsqueda en el Archivo Histórico del Diario Oficial El Peruano',
      og: true
    });
    this.seo.setCanonicalFromCurrentUrl();
  }

  ngAfterViewInit(): void {
    // No necesitamos agregar listeners aquí, se manejan en el HTML
  }

  // Efecto 3D que sigue al mouse (igual que portada-panel)
  onMouseMove(event: MouseEvent): void {
    const card = event.currentTarget as HTMLElement;
    const marcoContainer = card.querySelector('.marco-container') as HTMLElement;
    const imageContainer = card.querySelector('.imagen-container-holografico') as HTMLElement;

    if (!marcoContainer || !imageContainer) return;

    const rect = imageContainer.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateX = ((y - centerY) / centerY) * -5; // -5 a 5 grados
    const rotateY = ((x - centerX) / centerX) * 5;  // -5 a 5 grados

    // Calcular posición del brillo basada en el mouse (0 a 100%)
    const posX = (x / rect.width) * 100;
    const posY = (y / rect.height) * 100;

    // Aplicar transformación 3D al marco
    marcoContainer.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;

    // Mover el brillo siguiendo el mouse
    imageContainer.style.setProperty('--mouse-x', `${posX}%`);
    imageContainer.style.setProperty('--mouse-y', `${posY}%`);
  }

  onMouseLeave(event: MouseEvent): void {
    const card = event.currentTarget as HTMLElement;
    const marcoContainer = card.querySelector('.marco-container') as HTMLElement;
    const imageContainer = card.querySelector('.imagen-container-holografico') as HTMLElement;

    if (!marcoContainer || !imageContainer) return;

    marcoContainer.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg)';

    // Resetear posición del brillo
    imageContainer.style.removeProperty('--mouse-x');
    imageContainer.style.removeProperty('--mouse-y');
  }

  // Obtener la categoría opuesta para sugerencia
  getOppositeCategory(): string {
    const currentCat = this.searchCategory?.toLowerCase() || '';
    if (currentCat === 'portadas_historicas') {
      return 'fotografias';
    } else if (currentCat === 'fotografias') {
      return 'portadas_historicas';
    }
    return '';
  }

  // Obtener el nombre amigable de la categoría
  getCategoryName(cat: string): string {
    if (cat?.toLowerCase() === 'portadas_historicas') {
      return 'Portadas Históricas';
    } else if (cat?.toLowerCase() === 'fotografias') {
      return 'Fotografías';
    }
    return 'Todas las categorías';
  }

  // Generar URL de búsqueda en categoría opuesta
  getSuggestedSearchUrl(): string {
    const oppositeCategory = this.getOppositeCategory();
    if (!oppositeCategory) return '';

    let url = `/consultas?`;
    const params: string[] = [];

    if (this.searchTerm) {
      params.push(`q=${encodeURIComponent(this.searchTerm)}`);
    }

    if (this.searchStartDate && this.searchEndDate) {
      params.push(`fi=${this.searchStartDate}`);
      params.push(`ff=${this.searchEndDate}`);
    }

    params.push(`cat=${oppositeCategory}`);
    params.push(`page=1`);

    return url + params.join('&');
  }

  ngOnDestroy(): void {
    // Limpiar suscripción del rate limit
    if (this.rateLimitSubscription) {
      this.rateLimitSubscription.unsubscribe();
    }

    // Limpiar completamente todo el cache al destruir el componente
    this.clearProtectedImagesCache();
  }

}
